export { default as BlurGrp } from './images/BlurGrp.png'
export { default as erosuniverselogo } from './images/erosuniverselogo.png'
export { default as ErosuniverseImg } from './images/ErosuniverseImg.png'
export { default as Google } from './images/Google.png'
export { default as loginPageImg } from './images/LoginPageImg.png'
export { default as mainImage } from './images/mainimage.png'
export { default as multiFaceSwap } from './images/Multifaceswap.png'
export { default as NavigationBG } from './images/NavigationBG.png'
export { default as priyanka } from './images/priyanka.webp'
export { default as singleFaceSwap } from './images/Singlefaceswap.png'
export { default as Apple } from './images/Apple.png'
export { default as videoFaceSwap } from './images/Videofaceswap.png'
export const universe = '/images/universe-logo-v1.png'
export { default as appleLogo } from './images/appleLogo.png'
export { default as instaLogo } from './images/InstaLogo.png'
export { default as googleLogo } from './images/googleLogo.png'
export { default as addphoto } from './images/photo-add.svg'
export { default as bell } from './icons/bell.png'
export { default as face } from './icons/face.png'
export { default as search } from './icons/search.png'
export { default as home } from './icons/home.svg'
export { default as create } from './icons/create.svg'
export { default as discover } from './icons/discover.svg'
export { default as channel } from './icons/channel.svg'
export { default as store } from './icons/store.svg'
export { default as faceSwap } from './icons/face-swap.svg'
export { default as landingImage } from './images/landing.png'
export { default as videoMarker } from './icons/video.svg'
export { default as photoMarker } from './icons/photo.svg'
export { default as AItoolimg1 } from './icons/AI-tool-img1.png'
export { default as AItoolimg2 } from './icons/AI-tool-img2.png'
export { default as visibleIcon } from './icons/trailing-icon.png'
export { default as arrow } from './icons/arrow.png'
export { default as BookmarkIcon } from './icons/bookmark_icon.png'
export { default as BookmarkIconLight } from './icons/lightThemeIcons/bookmark-add_light.png'
export { default as MoreVerticalIcon } from './icons/more_vertical.png'
export { default as MoreVerticalIconLight } from './icons/lightThemeIcons/more_vert_light.png'
export { default as LikeIcon } from './icons/Like_icon.png'
export { default as LikeIconLight } from './icons/lightThemeIcons/like_light.png'
export { default as CommentIcon } from './icons/comment_icon.png'
export { default as CommentIconLight } from './icons/lightThemeIcons/comment_light.png'
export { default as shareIcon } from './icons/share_icon.png'
export { default as shareIconLight } from './icons/lightThemeIcons/share_light.png'
export { default as RemixIcon } from './icons/remix_icon.png'
export { default as remixButtonIcon } from './icons/remixButton.png'
export { default as photoIcon } from './icons/photosIcon.svg'
export { default as cameraIcon } from './icons/cameraIcon.svg'
export { default as fileIcon } from './icons/fileIcon.svg'
export { default as emailSent } from './icons/emailSent.png'
export { default as pwdsuccess } from './icons/pwdsuccess.png'
export { default as close } from './icons/close.png'
export { default as alert } from './icons/alert.png'
export { default as visibilityIcon } from './icons/visibility.png'
export { default as visibilityOffIcon } from './icons/visibility_off.png'
// Served from apps/super-app/public so index.html can preload it on /super-app-home (LCP).
// Bump the -v1 suffix when the image changes: nginx caches /images for a year.
export const HomePageBG = '/images/home-bg-v1.webp'
export { default as chevronRight } from './icons/chevron_right.png'
export { default as chevronDown } from './icons/chevron_right_down.png'
export { default as chevronUp } from './icons/chevronUp.png'
export { default as photoAdd } from './images/photo-add.svg'
export { default as creditsIcon } from './icons/credits_icon.svg'
export { default as popularToolsBg } from './images/PopularToolsBg.png'
export { default as scenceSwapIcon } from './icons/ScenceSwapIcon.svg'
export { default as favoriteImg } from './images/favorite.png'
export { default as passwordIcon } from './icons/password.png'
export { default as trailingIcon } from './icons/trailing-icon.png'
export { default as accountIcon } from './icons/account.png'
export { default as reportIcon } from './icons/report.png'
export { default as BlockUser } from  './icons/BlockUser.png'
export { default as upArrow } from './icons/upArrow.png'
export { default as TickIcon } from './icons/Tick.svg'
export { default as CrossIcon } from './icons/CrossIcon.svg'

export { default as homeWeb } from './icons/web/home.png'
export { default as voiceCloneIcon } from './icons/web/clone.svg'
export { default as discoverWeb } from './icons/web/discover.png'
export { default as createWeb } from './icons/web/create.png'
export { default as shopWeb } from './icons/web/shop.png'
export { default as channelWeb } from './icons/web/channel.png'
export { default as notification } from './icons/web/notification.png'
export { default as searchWeb } from './icons/web/search.png'
export { default as short_logo } from './icons/web/short_logo.png'
export { default as faceSwapIcon } from './icons/web/faceswap.png'
export { default as colorizeIcon } from './icons/web/colorize.png'
export { default as bgChange } from './icons/web/bgChange.png'
export { default as forwardButton } from './icons/forward_10s.svg'
export { default as rewindButton } from './icons/rewind-10s.svg'
export { default as helpIcon } from './icons/helpIcon.png'
export { default as viewIcon } from './icons/view_icon.png'
export { default as BackArrowIcon } from './icons/BackArrowIcon.png'
export { default as CloseIcon } from './icons/CloseIcon.png'
export { default as CloseIconLight } from './icons/CloseIconLight.png'
export { default as ColoriseIcon } from './icons/ColoriseIcon.png'
export { default as DiscardIcon } from './icons/Discard_icon.png'
export { default as EditIcon } from './icons/edit_icon.png'
export { default as logout } from './icons/logout.png'
export { default as SettingOptionIcon } from './icons/web/SettingOptionIcon.png'
export { default as noSoundIcon } from './icons/no_sound.png'
export { default as volumeIcon } from './icons/volume.png'
export { default as backBtn } from './icons/backBtn.png'
export { default as backBtnBlack } from './icons/backBtnBlack.png'
export { default as searchDark } from './icons/search-dark.png'
export { default as bellDark } from './icons/bell-dark.png'
export { default as discoverDark } from './icons/discover-dark.png'
export { default as createDark } from './icons/create-dark.png'

export { default as accountDeleted } from './icons/accountDeleted.png'
export { default as credits } from './icons/Credits.png'
export { default as credits_18 } from './icons/credits_18.png'

export { default as alertRed } from './icons/alertRed.png'
export { default as errorIcon } from './icons/errorIcon.svg'
export { default as coin } from './icons/coin.png'
export { default as coins_16 } from './icons/coins_16.png'

export { default as calender } from './icons/calender.png'
export { default as filterIcon } from './icons/filterIcon.png'
export { default as rightArrow } from './icons/rightArrow.png'
export { default as copy } from './icons/copy.png'
export { default as mcDonald } from './images/mcDonald.png'
export { default as gift } from './icons/gift.png'
export { default as bhim } from './icons/bhim.png'
export { default as credit_card } from './icons/credit_card.png'
export { default as credit_card_web} from './icons/credit_card_web.png'
export { default as flash } from './icons/flash.png'
export { default as done } from './icons/done.png'
export { default as notificatioNImg } from './images/notification_img.png'
export { default as MoreHorizontalIcon } from './icons/more_horizontal_icon.png'
export { default as MoreHorizontal } from './icons/more_horizontal.png'
export { default as secure } from './icons/secure.png'
export { default as check } from './icons/check.png'
export { default as greenCheck } from './icons/greenCheck.png'
export { default as LibraryPhoto } from './icons/photo.svg'
export { default as Avtar } from './images/avatar.png'
export { default as UserIcon } from './icons/user.png'
export { default as AvatarImg } from './images/AvatarEditProfile.png'
export { default as removeBtn } from './images/removeBtn.png'
export { default as uploadBtn } from './images/UploadBtn.png'
export { default as trashBtn } from './images/trash.png'
export { default as chevron_arrow_blue_down } from './icons/chevron_arrow_blue_down.png'
export { default as chevron_arrow_blue_up } from './icons/chevron_arrow_blue_up.png'
export { default as greyCheck } from './icons/greyCheck.png'
export { default as frame } from './icons/Frame.png'
export { default as badge } from './images/badge.png'
export { default as info } from './icons/info.png'
export { default as BackBtnWeb } from './icons/web/BackButton.png'
export { default as SavedContent } from './icons/SavedContent.png'
// Served from apps/super-app/public so index.html can preload it on /login (LCP).
// Bump the -v1 suffix when the image changes: nginx caches /images for a year.
export const SplashContent = '/images/login-splash-v1.png'
export { default as Credits } from './icons/Credits.png'
export { default as Coins } from './icons/Coins.png'
// export { default as TutotilImage1 } from './images/how-it-works-1.png'
// export { default as TutotilImage2 } from './images/how-it-works-2.png'
// export { default as TutotilImage3 } from './images/how-it-works-3.png'
// export { default as TutotilImage4 } from './images/how-it-works-4.png'
// export { default as TutotilImage5 } from './images/how-it-works-5.png'
export { default as HowItWork } from './images/howItWork.png'
export { default as WaitListBg } from './images/Waitlist_Bg.svg'
export { default as ErosLogoSVG } from './images/Eros_Logo.svg'
export { default as WaitListLandingBg } from './images/Landing_Bg.svg'
export { default as profileImageSmall } from './images/profileImage120.png'
export { default as profileImageBig } from './images/profileImage240.png'
export { default as placeholderImageSquare } from './images/placeholder-image_square.png'
export { default as placeholderImageHorizontalLarge } from './images/placeHolderImage/placeholder_image_horizontal_large.png'
export { default as placeholderImageHorizontal } from './images/placeHolderImage/placeholder_image_horizontal.png'
export { default as placeholderImageVerticalLarge } from './images/placeHolderImage/placeholder_image_vertical_large.png'
export { default as placeholderImageVertical } from './images/placeHolderImage/placeholder_image_vertical.png'
export { default as likeIcon } from './icons/like.svg'
export { default as unlikeIcon } from './icons/dislike.svg'
export { default as likedGreenIcon } from './icons/like-green.svg'
export { default as unlikeRedIcon } from './icons/dislike-red.svg'
export { default as createMenu } from './icons/web/createMenu.png'
export { default as eternal } from './icons/web/eternal.png'
export { default as os } from './icons/web/os.png'
export { default as world } from './icons/web/world.png'
export { default as play } from './icons/web/play.png'
export { default as cal } from './icons/web/cal.png'
export { default as gptSendIcon } from './icons/gptSendIcon.svg'
export { default as gptModelChangeIcon } from './icons/chevron_arrow_blue_down.png'
export { default as penIcon } from './icons/pen.png'
export { default as gptMoreIcon } from './icons/gptMoreIcon.svg'
export { default as calendarInputIcon } from './icons/calendar-input.png'
export { default as calendarIcon } from './icons/calender.png'
export { default as uploadIconBlue } from './icons/uploadIconBlue.svg'
export { default as uploadIconWhite } from './icons/uploadIconWhite.svg'
export { default as microPhone } from './icons/microPhone.svg'
export { default as WhiteTick } from './icons/White_Tick.svg'
export { default as PauseIcon } from './icons/PauseIcon.svg'
export { default as PlayIcon } from './icons/PlayIcon.svg'
export { default as AudioGraph } from './icons/AudioGraph.png'
export { default as Mic } from './icons/Mic.svg'
export { default as RecordStop } from './icons/RecordStop.svg'
export { default as RecordStart } from './icons/RecordStart.svg'
export { default as DragHandle } from './icons/Drag handle.svg'
export { default as DeleteIcon } from './icons/DeleteIcon.svg'
export { default as WhiteDeleteIcon } from './icons/Delete_White.svg'
export { default as DeleteIconWhiteDark } from './icons/DeleteIconWhiteDark.png'
export { default as EditPenIcon } from './icons/EditIcon.svg'
export { default as textToImageIcon } from './icons/web/text-to-image.png'
export { default as textToVideoIcon } from './icons/web/text-to-video.png'
export { default as zodiacWheel } from './eternal/images/zodiacWheel.png'
export { default as eternalOpeningPhone } from './eternal/images/Eternal-Opening-phone.png'
export { default as onboarding } from './eternal/images/onboarding.png'
export { default as stars } from './eternal/images/stars.png'
export { default as TimeIcon } from './eternal/icons/time.png'
export { default as GenderIcon } from './eternal/icons/gender.png'
export { default as Location } from './eternal/icons/location.png'
export { default as eternalBg } from './eternal/images/eternal-bg.png'
export { default as audioWav } from './eternal/images/audioWav.png'
export { default as vector } from './eternal/icons/vector.png'
export { default as starAnimate } from './eternal/images/Star-Animate.png'
export { default as starHead } from './eternal/images/starHead.png'
export { default as starHeadLight } from './eternal/images/starHeadLight.png'
export { default as deleteIconWhite } from './icons/deleteIconWhite.png'
export { default as ZodiacProto } from './eternal/images/Property-Default.png'
export { default as StarVector } from './eternal/images/StarVector.png'
export { default as StarVectorLight } from './eternal/images/StarVectorLight.png'
export { default as starAnimateLight } from './eternal/images/Star-Animate-light.png'
export { default as zodiacWheelLight } from './eternal/images/zodiacWheellight.png'
export { default as faceRead } from './eternal/images/faceRead.png'
export { default as voiceRemixIcon } from './icons/web/voice-remix.png'
export { default as MohommedRafiImg } from './images/Mohammed_Rafi.png'
export { default as audioWave } from './icons/waves.png'
export { default as audioMarker } from './icons/audioMarker.svg'
export { default as palmRead } from './eternal/images/palmRead.png'
export { default as upload } from './icons/upload.png'
export { default as createUniverse } from './images/createUniverse.png'
export { default as universeMobileLogo } from './images/universeMobileLogo.png'
export { default as audioBG } from './images/audioBG.svg'
export { default as clipIcon } from './icons/Clip.png'
export { default as extractIcon } from './icons/extractIcon.png'
export { default as Camera } from './icons/camera.png'
export { default as files } from './icons/files.png'
export { default as photo } from './icons/photo.png'
export { default as faceswapThumbnail } from './images/FaceSwap_thumbnail.png'
export { default as colorizeThumbnail } from './images/Colorise_thumbnail.png'
export { default as sceneSwapThumbnail } from './images/SceneSwap_thumbnail.png'
export { default as AudioOutputBg } from './images/AudioOutputBg.svg'

export { default as chatBotStar } from './eternal/images/chatBotStar.png'

// spiritual dashboard assets
export { default as spiritualWelcomeBG } from './eternal/images/spiritualWelcomeBG.png'
export { default as ErosLogo } from './eternal/images/ErosLogo.png'
export { default as filledStar } from './eternal/images/filledStar.png'
export { default as exploreLogo } from './eternal/images/exploreLogo.png'
export { default as ellipse } from './eternal/images/Ellipse.png'
export { default as ellipseLogo } from './eternal/images/Ellipse_logo.png'
export { default as heart } from './eternal/icons/heart.png'
export { default as soulReportExplore } from './eternal/images/soulReportExplore.jpg'
export { default as faceReadingExplore } from './eternal/images/faceReadingExplore.jpg'
export { default as torotReadingExplore } from './eternal/images/torotReadingExplore.jpg'
export { default as eternalLogo } from './eternal/images/logo-eternal-60.png'
// export { default as eternalLogoWeb } from './eternal/images/logo-eternal-120.png'
export { default as eternalLogoBig } from './eternal/images/logo-eternal-240.png'
export { default as tarrotCardBack } from './eternal/images/cardBack.png'
export { default as sendButton } from './eternal/images/sendButton.png'

/** AI TOOLS ICON */
export { default as actionGenerationIcon } from './aiToolsIcon/action-generator.png'
export { default as bgChangeIcon } from './aiToolsIcon/background-change.png'
export { default as colorizeIconLatest } from './aiToolsIcon/colorize.png'
export { default as faceSwapIconLatest } from './aiToolsIcon/face-swap.png'
export { default as imageToVideoIcon } from './aiToolsIcon/image-to-video.png'
export { default as talkingAvtarIcon } from './aiToolsIcon/talking-avatar.png'
export { default as textToImageIconLatest } from './aiToolsIcon/text-to-image.png'
export { default as textToVideoIconLatest } from './aiToolsIcon/text-to-video.png'
export { default as voiceCloneIconLatest } from './aiToolsIcon/voice-clone.png'
export { default as voiceRemixIconLatest } from './aiToolsIcon/voice-remix.png'

/** AI TOOLS ICON SVG */

export { default as actionGenerationIconSVG } from './aiToolsIcon/action-generator.svg'
export { default as bgChangeIconSVG } from './aiToolsIcon/background-change.svg'
export { default as colorizeIconLatestSVG } from './aiToolsIcon/colorize.svg'
export { default as faceSwapIconLatestSVG } from './aiToolsIcon/face-swap.svg'
export { default as imageToVideoIconSVG } from './aiToolsIcon/image-to-video.svg'
export { default as talkingAvtarIconSVG } from './aiToolsIcon/talking-avatar.svg'
export { default as textToImageIconLatestSVG } from './aiToolsIcon/text-to-image.svg'
export { default as textToVideoIconLatestSVG } from './aiToolsIcon/text-to-video.svg'
export { default as voiceCloneIconLatestSVG } from './aiToolsIcon/voice-clone.svg'
export { default as voiceRemixIconLatestSVG } from './aiToolsIcon/voice-remix.svg'
export { default as videoDubbingIconLatestPNG } from './aiToolsIcon/video-dubbing.png'
export { default as songGenerationIconLatestPNG } from './aiToolsIcon/song-generation.png'

export { default as starsDark } from './eternal/images/StarsDark.png'
export { default as starsLight } from './eternal/images/StarsLight.png'

export { default as dashboardIcon } from './icons/Dashboard.svg'
export { default as Music_Icon } from './icons/music_fallback.png'
export { default as fullScreen } from './icons/fullscreen.svg'
export { default as MotionControlIcon } from './icons/web/Motion_Control_Icon.png'
export { default as MotionControlBanner } from './icons/web/Motion-Control-Banner.png'

export { default as transactionClose } from './icons/transactionClose.png'
export { default as SortIcon } from './icons/sort_icon.png'
export { default as FilterDashboardIcon } from './icons/filter_dashboard_icon.png'
export { default as DownloadIcon } from './icons/Download_Icon.png'
export { default as otpAlertIcon } from './icons/otp_alert.png'

export { default as CopyLinkIcon } from './icons/copy_link.png'
export { default as WhatsAppIcon } from './icons/WhatsAppIcon.png'
export { default as FacebookIcon } from './icons/FacebookIcon.png'
export { default as TwitterIcon } from './icons/TwitterIcon.png'
export {default as InstagramIcon } from './icons/InstagramIcon.png'
export {default as MessengerIcon} from './icons/messenger.png'
export {default as MailIcon } from './icons/Mail.png'

export { default as audioPlayerThumbnail } from './images/audio_player_thumbnail.png'
export { default as VideoRecordIcon } from './icons/Video_Record_Icon.png'
export { default as VoiceRecordIcon } from './icons/Voice_Record_Icon.png'

export { ReactComponent as BlockUserDisplayIcon } from './icons/BlockUser.svg';
export { ReactComponent as ReportUserIcon } from './icons/report.svg';
export { ReactComponent as CreditsIcon } from './icons/CreditsIcon.svg';
export { default as RewardsIcon } from './icons/RewardsIcon.jsx';

export { ReactComponent as VideoIcon } from './icons/video.svg'
export { ReactComponent as ImageIcon } from './icons/photo.svg'
export { ReactComponent as SelectLangIcon} from './icons/SelectLangIcon.svg'
export { ReactComponent as NotificationIcon} from './icons/NotificationIcon.svg'
export { ReactComponent as FaqIcon} from './icons/FaqIcon.svg'
export { ReactComponent as DashboardNavIcon} from './icons/NavDashboardIcon.svg'
export { ReactComponent as ENLogoIcon} from './icons/ENLogoSVG.svg'
export { ReactComponent as PlainCoinIcon }  from './icons/Ellipse.svg' 
export { ReactComponent as SearchIcon} from './icons/SearchIcon.svg'

export { default as RewindIcon } from './icons/RewindIcon.jsx'
export { default as ForwardIcon } from './icons/ForwardIcon.jsx'
export { default as PauseVideoIcon } from './icons/PauseVideoIcon.jsx'
export { default as PlayVideoIcon } from './icons/PlayVideoIcon.jsx'
export { ReactComponent as FullscreenIcon } from './icons/fullscreen.svg'
export { default as VolumeIcon } from './icons/VolumeIcon.jsx'
export { default as MuteIcon } from './icons/MuteIcon.jsx'

export {ReactComponent as EditProfileIcon} from "./icons/EditProfile.svg"
export {ReactComponent as ErosIdIcon} from "./icons/ErosIdImage.svg"
export {ReactComponent as SaveCardIcon} from "./icons/SaveCardIcon.svg"

export {ReactComponent as UploadBannerIcon} from "./icons/UploadIcon.svg"
export {ReactComponent as ActiveNewCheckIcon} from "./icons/ActiveCheckIcon.svg"

export {ReactComponent as InfoBlueIcon} from "./icons/InfoBlueIcon.svg"
export {ReactComponent as DownloadCardIcon} from "./icons/DownloadIcon.svg"
export {ReactComponent as ZoomInIcon} from"./icons/ZoomInIcon.svg"
export {ReactComponent as ZoomOutIcon} from"./icons/ZoomOutIcon.svg"
export {ReactComponent as RotateIcon} from"./icons/RotateIcon.svg"
export {ReactComponent as ModalCloseIcon} from "./icons/ModalCloseIcon.svg"